import React, { useState } from 'react';
import { Card, CardContent, Typography, Button, Box, Container, Alert, CircularProgress } from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../../../services/api';
import { tenantConfig } from '../../../config/tenantConfig';

const SwitchApplicantPage = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    // Dynamically pull branding based on the tenant (BrightSparc vs JB Marks)
    const primaryColor = tenantConfig.primaryColor || '#6a11cb';
    const displayLogo = tenantConfig.logoUrl || tenantConfig.logo;

    const handleSwitch = async () => {
        if (!token) {
            setError('Invalid or missing verification token.');
            return;
        }

        setLoading(true);
        setError('');
        setMessage('');

        try {
            // Adjust the prefix here if your auth routes sit behind something other than '/auth'
            const response = await api.post('/auth/switch-to-applicant', { token });
            setMessage(response.data.message || 'Account successfully switched to Applicant. You can now log in.');
        } catch (err) {
            setError(err.response?.data?.message || 'An error occurred while switching your account.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ minHeight: 'calc(100vh - 80px)', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: primaryColor, padding: 4 }}>
            <Container maxWidth="sm">
                <Card sx={{ boxShadow: 6, borderRadius: 2 }}>
                    <CardContent sx={{ padding: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                        
                        {displayLogo && (
                            <Box component="img" src={displayLogo} alt={tenantConfig.name} sx={{ height: 60, mb: 3, objectFit: 'contain' }} />
                        )}

                        <Typography variant="h5" gutterBottom fontWeight="bold">
                            Switch to Applicant
                        </Typography>

                        {!message && !error && (
                            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                                You are about to cancel your Funder registration and downgrade your account to an <strong>Applicant</strong>. This will safely remove your organizational setup and allow you to apply for bursaries immediately.
                            </Typography>
                        )}

                        {message && <Alert severity="success" sx={{ mb: 3, width: '100%', textAlign: 'left' }}>{message}</Alert>}
                        {error && <Alert severity="error" sx={{ mb: 3, width: '100%', textAlign: 'left' }}>{error}</Alert>}
                        
                        {!message && (
                            <Button 
                                onClick={handleSwitch}
                                disabled={loading || !token}
                                fullWidth 
                                variant="contained" 
                                sx={{ 
                                    py: 1.5, 
                                    mb: 2,
                                    backgroundColor: primaryColor, 
                                    fontWeight: 'bold',
                                    '&:hover': { filter: 'brightness(0.9)' } 
                                }}
                            >
                                {loading ? <CircularProgress size={24} color="inherit" /> : 'Confirm & Switch Account'}
                            </Button>
                        )}

                        <Box sx={{ mt: 2 }}>
                            <Link to="/login" style={{ color: primaryColor, textDecoration: 'none', fontWeight: 'bold' }}>
                                {message ? "Proceed to Login" : "Cancel & Go to Login"}
                            </Link>
                        </Box>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
};

export default SwitchApplicantPage;